import { render, staticRenderFns } from "./FinancialComponent.vue?vue&type=template&id=97be1ed2&scoped=true&"
import script from "./FinancialComponent.vue?vue&type=script&lang=js&"
export * from "./FinancialComponent.vue?vue&type=script&lang=js&"
import style0 from "./FinancialComponent.vue?vue&type=style&index=0&id=97be1ed2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97be1ed2",
  null
  
)

export default component.exports